import ApiService from "@/core/services/api.service";

const actions = {
  /**
   * Add staff in facial device
   * @param context
   * @param payload
   * @returns {*}
   */
  addStaffInFacialDevice(context, payload) {
    ApiService.setHeader();
    return ApiService.post("school/device/facial/staff", payload).then(
      (response) => response
    );
  },
};

export default {
  actions,
};
